export enum DetailsTableValueType {
  Text = 'text',
  Url = 'url',
  Image = 'image',
  Status = 'status',
}
